import React from "react";
import "./App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DepositProvider } from "./context/DepositContext";
import Layout from "./components/Layout";
import { Toaster } from "./components/ui/toaster";

import Home from "./pages/Home";
import Trips from "./pages/Trips";
import TripDetail from "./pages/TripDetail";
import PlanYourTrip from "./pages/PlanYourTrip";
import SanJuanDelSur from "./pages/SanJuanDelSur";
import SpeciesHub from "./pages/SpeciesHub";
import SpeciesList from "./pages/SpeciesList";
import SpeciesDetail from "./pages/SpeciesDetail";
import FishingCalendar from "./pages/FishingCalendar";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Weather from "./pages/Weather";
import Book from "./pages/Book";
import Admin from "./pages/admin/Admin";
import { Toaster as SonnerToaster } from "./components/ui/sonner";
import OwnerNotifier from "./components/OwnerNotifier";

const StaticRedirect = ({ to }) => {
  React.useEffect(() => { window.location.replace(to); }, [to]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <OwnerNotifier />
      <SonnerToaster position="top-right" richColors closeButton />
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route
          path="*"
          element={
            <DepositProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/trips" element={<Trips />} />
                  <Route path="/trips/:slug" element={<TripDetail />} />
                  <Route path="/plan-your-trip" element={<PlanYourTrip />} />
                  <Route path="/san-juan-del-sur-fishing" element={<SanJuanDelSur />} />
                  <Route path="/species" element={<SpeciesHub />} />
                  <Route path="/offshore-species" element={<SpeciesList zone="offshore" />} />
                  <Route path="/inshore-species" element={<SpeciesList zone="inshore" />} />
                  <Route path="/bottom-species" element={<SpeciesList zone="bottom" />} />
                  <Route path="/species/:slug" element={<SpeciesDetail />} />
                  <Route path="/fishing-calendar" element={<FishingCalendar />} />
                  <Route path="/weather" element={<Weather />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/book" element={<Book />} />
                  <Route path="/sitemap" element={<StaticRedirect to="/sitemap.xml" />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Toaster />
              </Layout>
            </DepositProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
